import React, { FC } from "react";
import { LuPenLine } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

import { isPdfName, signatureRequestPath } from "./signature.utils";

/**
 * Icon-only "Request signature" button on a file row of the client profile's Files card
 * (owner 2026-10-28, Loom 2cc3346e: a third icon next to share and delete, no words).
 * Shown for PDFs only.
 */
export const RequestSignatureIcon: FC<{
  customerId: string;
  fileId: string;
  name?: string | null;
}> = ({ customerId, fileId, name }) => {
  const navigate = useNavigate();
  if (!isPdfName(name)) return null;
  return (
    <button
      type={"button"}
      title={"Request signature"}
      aria-label={"Request signature"}
      data-testid={"request-signature-icon"}
      onClick={(e) => {
        e.stopPropagation();
        navigate(signatureRequestPath(customerId, fileId, name));
      }}
      className={
        "flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-[#E4E7EC] bg-white text-[#9097A8] hover:bg-[#F4F2FF] hover:text-[#6B4EFF]"
      }>
      <LuPenLine size={15} />
    </button>
  );
};
